<div
    class="count-card"
    [class.active-card]="
        selectedFilter === title + '-' + activeLabel ||
        selectedFilter === title + '-' + upcomingLabel
    "
>
    <div class="card-content">
        <div class="card-headerr row">
            <!-- Left Column - col-4 -->
            <div class="col-4 title-section">
                <div class="font-semibold title">{{ title }}</div>
                <div class="count-text-color text-2xl font-bold">
                    {{ totalCount }}
                </div>
            </div>

            <!-- Right Column - col-8 -->
            <div class="col-8 progress-section px-2 py-3">
                <div class="w-full">
                    <div
                        class="custom-progress-bar"
                        style="
                            display: flex;
                            height: 20px !important;
                            border-radius: 8px;
                            overflow: hidden;
                        "
                    >
                        <div
                            *ngIf="activeProgressPercentage >= 0"
                            [style.width.%]="activeProgressPercentage"
                            [style.backgroundColor]="activeColor"
                            style="height: 100%"
                        ></div>
                        <div
                            *ngIf="upcomingProgressPercentage >= 0"
                            [style.width.%]="upcomingProgressPercentage"
                            [style.backgroundColor]="upcomingColor"
                            style="height: 100%"
                        ></div>
                        <div
                            *ngIf="
                                showSignedOut &&
                                signedOutProgressPercentage >= 0
                            "
                            [style.width.%]="signedOutProgressPercentage"
                            [style.backgroundColor]="signedOutColor"
                            style="height: 100%"
                        ></div>
                        <div
                            *ngIf="
                                showNotMarked &&
                                notMarkedProgressPercentage >= 0
                            "
                            [style.width.%]="notMarkedProgressPercentage"
                            [style.backgroundColor]="notMarkedColor"
                            style="height: 100%"
                        ></div>
                        <div
                            *ngIf="remainingProgressPercentage >= 0"
                            [style.width.%]="remainingProgressPercentage"
                            [style.backgroundColor]="remainingColor"
                            style="height: 100%"
                        ></div>
                    </div>
                </div>
                <!-- Labels Grid Container - Dynamic 1x2 or 2x2 layout -->
                <div class="labels-grid" [class.four-labels]="showSignedOut && showNotMarked">
                    <span
                        class="label-item"
                    >
                        <i
                            class="pi pi-circle-fill"
                            [ngStyle]="{
                                'font-size': '9px',
                                color: activeColor,
                            }"
                        ></i>
                        &nbsp;
                        <span
                            class="font-normal text-sm filter-label"
                            [class.active-label]="
                                selectedFilter === title + '-' + activeLabel
                            "
                            (click)="onFilterClick(title, activeLabel)"
                            [attr.title]="''"
                        >
                            {{ activeLabel }} ({{ activeCount }})
                        </span>
                    </span>
                    <span
                        class="label-item"
                    >
                        <i
                            class="pi pi-circle-fill"
                            [ngStyle]="{
                                'font-size': '9px',
                                color: upcomingColor,
                            }"
                        ></i
                        >&nbsp;
                        <span
                            class="font-normal text-sm filter-label"
                            [class.active-label]="
                                selectedFilter === title + '-' + upcomingLabel
                            "
                            (click)="onFilterClick(title, upcomingLabel)"
                            [attr.title]="''"
                        >
                            {{ upcomingLabel }} ({{ upcomingCount }})
                        </span>
                    </span>
                    <span
                        *ngIf="showSignedOut"
                        class="label-item"
                    >
                        <i
                            class="pi pi-circle-fill"
                            [ngStyle]="{
                                'font-size': '9px',
                                color: signedOutColor,
                            }"
                        ></i
                        >&nbsp;
                        <span
                            class="font-normal text-sm filter-label"
                            [class.active-label]="
                                selectedFilter === title + '-' + signedOutLabel
                            "
                            (click)="onFilterClick(title, signedOutLabel)"
                            [attr.title]="''"
                        >
                            {{ signedOutLabel }} ({{ signedOutCount }})
                        </span>
                    </span>
                    <span
                        *ngIf="showNotMarked"
                        class="label-item"
                    >
                        <i
                            class="pi pi-circle-fill"
                            [ngStyle]="{
                                'font-size': '9px',
                                color: notMarkedColor,
                            }"
                        ></i
                        >&nbsp;
                        <span
                            class="font-normal text-sm filter-label"
                            [class.active-label]="
                                selectedFilter === title + '-' + notMarkedLabel
                            "
                            (click)="onFilterClick(title, notMarkedLabel)"
                            [attr.title]="''"
                        >
                            {{ notMarkedLabel }} ({{ notMarkedCount }})
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
